import { z } from 'zod';

import { GeographicalZoneAddressSchema } from './GeographicalZoneAddressSchema';

export const GeographicalZoneSchema = z.object({
  id: z.string().or(z.number()),
  name: z
    .string()
    .min(1, 'Название обязательно для заполнения')
    .max(150, 'Название не должно превышать 150 символов')
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  description: z
    .string()
    .max(300, 'Описание не должно превышать 300 символов')
    .optional()
    .or(z.literal('')),
  addresses: z.array(GeographicalZoneAddressSchema).optional(),
  avgTransportSpeed: z
    .object({
      id: z.number().or(z.string()),
      label: z.string()
    })
    .nullable()
    .refine((value) => value !== null, {
      message: 'Средняя скорость движения обязательна для заполнения'
    })
});

